import React from "react";
import PropTypes from "prop-types";
import MaterialTable from "material-table";
import { tableIcons, getTableHeader } from "../utils/tableHeaders";
import { SubscriptionTableControls } from "./SubscriptionTableControls";

/**
 * Canceled subscriptions table component
 */
export const CanceledSubscriptionTable = ({
  data,
  selectionRange,
  onRangeChange,
  openDialog,
  onOpenDialog,
  selectedPlan,
  onPlanChange,
}) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div style={{ width: "100%" }}>
      <SubscriptionTableControls
        selectionRange={selectionRange}
        onRangeChange={onRangeChange}
        openDialog={openDialog}
        onOpenDialog={onOpenDialog}
        selectedPlan={selectedPlan}
        onPlanChange={onPlanChange}
      />
      <MaterialTable
        style={{ marginTop: "10px", marginBottom: "10px" }}
        icons={tableIcons}
        key="totalCanceledTable"
        title={
          <div style={{ marginTop: "10px" }}>
            <h2>
              All Canceled Subscriptions (Excluding manually created
              subscriptions)
            </h2>
            <p style={{ fontSize: "125%" }}>
              Overall column contains the total number of canceled subscriptions
              for each plan
            </p>
          </div>
        }
        columns={getTableHeader("totalCanceled")}
        data={data}
        options={{
          selection: false,
          sorting: false,
          search: false,
          paging: false,
          exportAllData: true,
          exportButton: true,
          exportFileName:
            "All Canceled Subscriptions (Excluding manually created subscriptions)",
          rowStyle: (x) => {
            if (x.tableData.id % 2) {
              return { backgroundColor: "#f2f2f2" };
            }
          },
        }}
      />
    </div>
  );
};

CanceledSubscriptionTable.propTypes = {
  data: PropTypes.array.isRequired,
  selectionRange: PropTypes.object.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  openDialog: PropTypes.bool.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  selectedPlan: PropTypes.string.isRequired,
  onPlanChange: PropTypes.func.isRequired,
};

